import React, {useEffect, useReducer, useState} from "react";
import LoadingOverlay from "../../../components/LoadingOverlay";
import {T2} from "../../../styles/titles";
import {Totals} from "../painelDeDepositos/components/totals";
import {Container} from "../painelDeDepositos/styles";
import EfeitoDeContratoService from "./service/efeitoDeContratoService";
import LiveTable from "./components/liveTable";
import {useLocation} from "react-router-dom";
import {FormFilter} from "./components/filter";
import {EfeitoContratoFilterProps, IFormProps} from "./types";
const EfeitoDeContrato: React.FC = () =>{

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const efeitoDeContrato = new EfeitoDeContratoService();
  const [filterData, setFilterData] = useState<any>(null);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [dataFilterState, setDataFilterState] = useState({
    settlementDate: '',
    finalReceiverUser: '',
    status: '',
    ispb: '',
  });
  const handleFilter = async(filter: EfeitoContratoFilterProps) => {
    setFilterData(filter)
  };



  return(
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />
      <T2>Efeito de Contrato</T2>
      <FormFilter   onFormSubmit={handleFilter}
                    loading={isLoading}
                    setLoading={setIsLoading}
                    filter={dataFilterState}/>
      <LiveTable   dataFilter={filterData}
                   pageSize={100}
                   currentPage={currentPage}
                   onPageChange={setCurrentPage}
                   onPageSizeChange={setPageSize} />
    </Container>
  )
}
export default EfeitoDeContrato;
